import axios from 'axios';
import {
  CircularProgress, Backdrop, Paper, Table, TableBody, TableCell, TableContainer, TableHead,
  TablePagination, TableRow, Grid, Container, Button, Typography
} from '@material-ui/core';
import moment from 'moment';
import React, { PureComponent } from 'react';
import { Modal } from 'react-bootstrap';
import { getAPIUrl } from '../../helpers/CommonHelper';
import '../../styles/DriverComponent.css';

class DriverComponent extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      page: 0,
      driver: [],
      rowsPerPage: 10,
      totalItem: 0,
      selected: {
        license: '',
        insurance: ''
      }
    };
  }

  componentDidMount() {
    this.fetchDriverDetails();
  }

  fetchDriverDetails = () => {
    this.setState({
      isLoading: true
    });
    axios.get(`${getAPIUrl()}/admin/driver/all`, {
      timeout: 30000,
      headers: {
        'Authorization': this.props.token
      }
    }).then((resp) => {
      this.setState({
        isLoading: false,
        driver: resp.data.data,
        totalItem: resp.data.totalItem
      });
    }).catch((error) => {
      console.error(error);
      this.setState({
        isLoading: false,
      });
      if (error.response && error.response.status === 401) {
        alert('Session expired!! Please login again');
        this.props.logout();
      } else {
        alert('Something went wrong!!!');
      }
    });
  }

  updateDriverDetail = (type) => {
    this.setState({
      showModal: false,
      isLoading: true
    });
    const { selected } = this.state;
    axios.put(`${getAPIUrl()}/admin/driver/verify/${selected.emailId}`, {
      active: type
    } , {
      timeout: 30000,
      headers: {
        'Authorization': this.props.token
      }
    }).then(() => {
      this.fetchDriverDetails();
    }).catch((error) => {
      console.error(error);
      this.setState({
        isLoading: false,
      });
      if (error.response && error.response.status === 401) {
        alert('Session expired!! Please login again');
        this.props.logout();
      } else {
        alert('Something went wrong!!!');
      }
    });
  }

  handleChangePage = (event, newPage) => {
    this.setState({
      page: newPage
    });
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0
    });
  }

  handleModalShow = (row) => {
    this.setState({
      showModal: true,
      selected: row
    });
  }

  handleModalClose = () => {
    this.setState({
      showModal: false
    });
  }

  render() {
    return (
      <Paper className="table-container">
        <TableContainer className="container">
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableCell align="center">EmailId</TableCell>
                <TableCell align="center">Active</TableCell>
                <TableCell align="center">First name</TableCell>
                <TableCell align="center">Last name</TableCell>
                <TableCell align="center">Phone number1</TableCell>
                <TableCell align="center">License</TableCell>
                <TableCell align="center">Vehicle type</TableCell>
                <TableCell align="center">Vehicle color</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.state.driver.length > 0 && this.state.driver.slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).map((row) => {
                return (
                  <TableRow hover key={row.emailId} onClick={() => this.handleModalShow(row)}>
                    <TableCell align="center" style={{ minWidth: 100 }}>
                      {row.emailId}
                    </TableCell>
                    <TableCell align="center" style={{ maxWidth: 20 }}>
                      {row.active ? "YES" : "NO"}
                    </TableCell>
                    <TableCell align="center" style={{ maxWidth: 150 }}>
                      {row.firstName}
                    </TableCell>
                    <TableCell align="center" style={{ maxWidth: 150 }}>
                      {row.lastName}
                    </TableCell>
                    <TableCell align="center" style={{ maxWidth: 50 }}>
                      {row.number1}
                    </TableCell>
                    <TableCell align="center" style={{ minWidth: 100 }}>
                      {row.licenseNumber} <br />
                      {moment(row.licenseExpiry).format('MM-DD-YYYY, h:mm a')}
                    </TableCell>
                    <TableCell align="center" style={{ maxWidth: 50 }}>
                      {row.vehicleType}
                    </TableCell>
                    <TableCell align="center" style={{ maxWidth: 50 }}>
                      {row.vehicleColor}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 100]}
          component="div"
          count={this.state.totalItem}
          rowsPerPage={this.state.rowsPerPage}
          page={this.state.page}
          onChangeRowsPerPage={this.handleChangeRowsPerPage}
          onChangePage={this.handleChangePage}
        />
        <Backdrop className="loading-indicator" open={this.state.isLoading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <Modal show={this.state.showModal} onHide={this.handleModalClose}>
          <Modal.Body>
            <Container>
              <Grid item xs={12} sm={12} md={12}>
                <Typography variant="h6" gutterBottom>
                  Insurance photo
                </Typography>
                <img src={this.state.selected.insurance} width="300" />
                <Typography variant="h6" gutterBottom>
                  License photo
                </Typography>
                <img src={this.state.selected.license} width="300" />
              </Grid>
            </Container>
          </Modal.Body>
          <Modal.Footer>
            <Button color="secondary" disableElevation onClick={() => this.updateDriverDetail(false)}>Block</Button>
            <Button color="primary" disableElevation onClick={() => this.updateDriverDetail(true)}>Enable</Button>
            <Button disableElevation onClick={this.handleModalClose}>Close</Button>
          </Modal.Footer>
        </Modal>
      </Paper>
    )
  }
}

export default DriverComponent;
